module.exports = __webpack_public_path__ + "908e4d2e/img/file-icon.c085e21e.svg";